module.exports = __webpack_public_path__ + "img/pulsepoint_hcp365_plugin.0c90b5ab.svg";